export default (error) => {
  console.debug("AUTH HANDLER FIRE");
  if (error.response && error.response.status == 401) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    return false;
  }
  return true;
};
